import { render } from "./StatsView.vue?vue&type=template&id=46919ce2"
import script from "./StatsView.vue?vue&type=script&lang=js"
export * from "./StatsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fae/dev/grazer/grazer-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__